import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Loading from './Loading';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const redirectRef = useRef<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const handleCallback = async () => {
      const start = Date.now();
      let user: any = null;

      // Esperar un poco a que Supabase procese la sesión
      while (!cancelled && Date.now() - start < 4000 && !user) {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          user = session.user;
          break;
        }
        await new Promise(resolve => setTimeout(resolve, 150));
      }

      // Determinar destino en base a lo que se guardó antes de iniciar OAuth
      let target: string = '/seleccion';
      try {
        // Leer de localStorage solo una vez y guardarlo en un ref, para que
        // aunque el efecto se ejecute dos veces, usemos siempre el mismo valor.
        if (redirectRef.current === null) {
          const stored = window.localStorage.getItem('redirectAfterOAuth');
          redirectRef.current = stored;
          window.localStorage.removeItem('redirectAfterOAuth');
        }

        console.debug('AuthCallback: redirectAfterOAuth stored =', redirectRef.current);

        const storedValue = redirectRef.current;
        if (storedValue && typeof storedValue === 'string') {
          // stored suele ser /busco-niva/login o /soy-niva/login (con o sin query)
          if (storedValue.includes('/busco-niva')) {
            target = '/busco-niva/perfiles';
          } else if (storedValue.includes('/soy-niva')) {
            target = '/soy-niva/mapa';
          }
        }

        // Si ya tenemos user, ver si existe fila en usuarios y si el perfil está completo
        if (user) {
          const { data: usuario } = await supabase
            .from('usuarios')
            .select('tipo, nombre, apellido, antecedentes_penales_url')
            .eq('id', user.id)
            .maybeSingle();

          const vieneDeSoyNiva = !!(storedValue && storedValue.includes('/soy-niva'));
          const vieneDeBuscoNiva = !!(storedValue && storedValue.includes('/busco-niva'));

          const perfilIncompletoSoy = !usuario || !usuario.nombre || !usuario.apellido || !usuario.antecedentes_penales_url;
          const perfilIncompletoBusco = !usuario || !usuario.nombre || !usuario.apellido;

          // Soy Niva: si no hay usuario o el perfil está incompleto, ir al onboarding Google Soy Niva
          if (vieneDeSoyNiva && perfilIncompletoSoy) {
            target = '/soy-niva/registro-google';
          // Busco Niva: si no hay usuario o el perfil está incompleto, ir al onboarding Google Busco Niva
          } else if (vieneDeBuscoNiva && perfilIncompletoBusco) {
            target = '/busco-niva/registro-google';
          } else if (usuario && usuario.tipo) {
            // Si existe usuario y ya tiene tipo, respetar su rol
            if (usuario.tipo === 'empleador') {
              target = '/busco-niva/perfiles';
            } else if (usuario.tipo === 'iyire') {
              target = '/soy-niva/mapa';
            }
          }
        }

        console.debug('AuthCallback: final target =', target);
      } catch (e) {
        console.error('AuthCallback: error leyendo redirectAfterOAuth', e);
      }

      if (!cancelled) {
        navigate(target, { replace: true });
      }
    };

    handleCallback();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return <Loading />;
};

export default AuthCallback;
